import { UserActionTypes, LoginCredentials } from './user.types';
import { IUser } from '../../types';

// Initialization action creators
export const initializeAuth = () => ({
  type: UserActionTypes.INITIALIZE_AUTH,
});

// Authentication action creators
export const loginRequest = (credentials: LoginCredentials) => ({
  type: UserActionTypes.LOGIN_REQUEST,
  payload: credentials,
});

export const loginSuccess = (user: IUser) => ({
  type: UserActionTypes.LOGIN_SUCCESS,
  payload: user,
});

export const loginFailure = (error: string) => ({
  type: UserActionTypes.LOGIN_FAILURE,
  payload: error,
});

// Logout action creators
export const logoutRequest = () => ({
  type: UserActionTypes.LOGOUT_REQUEST,
});

export const logoutSuccess = () => ({
  type: UserActionTypes.LOGOUT_SUCCESS,
});

export const logoutFailure = (error: string) => ({
  type: UserActionTypes.LOGOUT_FAILURE,
  payload: error,
});

// User registration action creators
export const registerRequest = (userData: Partial<IUser>) => ({
  type: UserActionTypes.REGISTER_REQUEST,
  payload: userData,
});

export const registerSuccess = (user: IUser) => ({
  type: UserActionTypes.REGISTER_SUCCESS,
  payload: user,
});

export const registerFailure = (error: string) => ({
  type: UserActionTypes.REGISTER_FAILURE,
  payload: error,
});

// User profile action creators
export const getUserProfileRequest = (userId: string) => ({
  type: UserActionTypes.GET_USER_PROFILE_REQUEST,
  payload: userId,
});

export const getUserProfileSuccess = (userProfile: IUser) => ({
  type: UserActionTypes.GET_USER_PROFILE_SUCCESS,
  payload: userProfile,
});

export const getUserProfileFailure = (error: string) => ({
  type: UserActionTypes.GET_USER_PROFILE_FAILURE,
  payload: error,
});

// Update user profile action creators
export const updateUserProfileRequest = (profileData: Partial<IUser>) => ({
  type: UserActionTypes.UPDATE_USER_PROFILE_REQUEST,
  payload: profileData,
});

export const updateUserProfileSuccess = (userProfile: IUser) => ({
  type: UserActionTypes.UPDATE_USER_PROFILE_SUCCESS,
  payload: userProfile,
});

export const updateUserProfileFailure = (error: string) => ({
  type: UserActionTypes.UPDATE_USER_PROFILE_FAILURE,
  payload: error,
});

// Clear user action creators
export const clearUserError = () => ({
  type: UserActionTypes.CLEAR_USER_ERROR,
});

export const clearUserSuccess = () => ({
  type: UserActionTypes.CLEAR_USER_SUCCESS,
});

// Set user data action creators
export const setUserData = (userData: IUser) => ({
  type: UserActionTypes.SET_USER_DATA,
  payload: userData,
});

export const clearUserData = () => ({
  type: UserActionTypes.CLEAR_USER_DATA,
});

// Get user data action creators
export const getUserDataRequest = () => ({
  type: UserActionTypes.GET_USER_DATA_REQUEST,
});

export const getUserDataSuccess = (userData: IUser) => ({
  type: UserActionTypes.GET_USER_DATA_SUCCESS,
  payload: userData,
});

export const getUserDataFailure = (error: string) => ({
  type: UserActionTypes.GET_USER_DATA_FAILURE,
  payload: error,
});

// Get workspace data action creators
export const getWorkspaceDataRequest = () => ({
  type: UserActionTypes.GET_WORKSPACE_DATA_REQUEST,
});

export const getWorkspaceDataSuccess = (workspaceData: any) => ({
  type: UserActionTypes.GET_WORKSPACE_DATA_SUCCESS,
  payload: workspaceData,
});

export const getWorkspaceDataFailure = (error: string) => ({
  type: UserActionTypes.GET_WORKSPACE_DATA_FAILURE,
  payload: error,
});
